// ImageSlider.js
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const ImageSlider = ({ images }) => {
    const hasMultiple = images?.length > 1;
    return (
        <Swiper
            modules={[Pagination, Navigation]}
            pagination={hasMultiple ? { clickable: true } : false}
            navigation={hasMultiple}
            spaceBetween={30}
            slidesPerView={1}
        >
            {images.map((data, index) => (
                <SwiperSlide key={index}>
                    <div
                        style={{
                            width: "100%",
                            height: "270px", // set desired height
                            // overflow: "hidden",
                            // display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <img src={data?.image_path} alt={`Slide ${index}`}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "fill", // or 'cover' or 'fill' depending on your need
                                // borderRadius: "10px"
                            }} />
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default ImageSlider;
